// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-house-system-radio[data-v-671f29f8] .v-radio:not(.v-item--active) .v-icon.v-icon{color:#bdbdbd!important}", ""]);
// Exports
module.exports = exports;
